export enum AppFilterButtonType {
  LINK = 'LINK',
  BOLD = 'BOLD',
  PRIMARY_BUTTON = 'PRIMARY-BUTTON',
  SECONDARY_BUTTON = 'SECONDARY-BUTTON',
  SECONDARY_BUTTON_WITH_PERMISSIONS = 'SECONDARY-BUTTON-WITH-PERMISSIONS',
  DELETE_ALL_BUTTON = 'DELETE-ALL-BUTTON',
  DROPDOWN_BUTTON = 'DROPDOWN-BUTTON'
}

export interface AppFilterButton {
  id: string;
  title: string;
  type: AppFilterButtonType;
  isHidden?: boolean;
  isDisabled?: boolean;
  hasLoadingSpinner?: boolean;
  hasSpinner?: boolean;
  customClass?: string;
  auth?: string;
  desc?: string;
  dropdownConfig?: {
    buttonType: 'primary-button' | 'secondary-button';
    options: Array<{
      id: string;
      label: string;
      disabled?: boolean;
      extraClass?: string;
    }>;
  };
}
